export { updateType };
import { assert } from './assert.js';
/** Help TypeScript update the type of dynamically modified objects. */
function updateType(thing, clone) {
    // @ts-ignore
    assert(thing === clone);
}
